import React, { useState } from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const [includeColorimetria, setIncludeColorimetria] = useState(false);
  const basePrice = 19990;
  const basePriceOriginal = 49990;
  const colorimetriaPrice = 7000;
  const colorimetriaPriceOriginal = 26990;
  const totalPrice = includeColorimetria ? basePrice + colorimetriaPrice : basePrice;
  const totalPriceOriginal = includeColorimetria ? basePriceOriginal + colorimetriaPriceOriginal : basePriceOriginal;
  // Calcular porcentaje de descuento
  const discountPercentage = Math.round((totalPriceOriginal - totalPrice) / totalPriceOriginal * 100);
  return <section className="w-full bg-[#0a0a0a] py-16 md:py-24 px-4" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        {/* Título más vendible */}
        <div className="text-center mb-12" data-id="element-150">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-4 leading-tight" data-id="element-151">
            ¡ACCEDÉ A LA FORMACIÓN <span className="text-[#c41e3a]" data-id="element-152">HOY!</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 font-semibold" data-id="element-153">
            Transformá tu carrera como barbero profesional
          </p>
        </div>

        <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl p-8 md:p-12 border-4 border-[#c41e3a] shadow-2xl" data-id="element-154">
          {/* Price con descuento */}
          <div className="text-center mb-10" data-id="element-155">
            {/* Badge de descuento porcentual */}
            <div className="inline-block bg-gradient-to-r from-[#c41e3a] to-[#d91e5b] text-white px-8 py-3 rounded-full font-black text-2xl mb-4 shadow-lg" data-id="element-156">
              🔥 {discountPercentage}% OFF
            </div>

            {/* Precio original tachado */}
            <div className="mb-3" data-id="element-157">
              <span className="text-3xl md:text-4xl text-gray-500 line-through font-bold" data-id="element-158">
                ${totalPriceOriginal.toLocaleString('es-AR')}
              </span>
            </div>

            {/* Precio actual */}
            <div className="flex items-baseline justify-center gap-3 mb-3" data-id="element-159">
              <span className="text-6xl md:text-7xl font-black text-white" data-id="element-160">
                ${totalPrice.toLocaleString('es-AR')}
              </span>
              <span className="text-3xl text-gray-400 font-bold" data-id="element-161">ARS</span>
            </div>

            {includeColorimetria && <p className="text-gray-400 text-lg font-semibold" data-id="element-162">
                Incluye Método Barber Pro + Colorimetría
              </p>}
          </div>

          {/* Includes */}
          <div className="space-y-5 mb-10" data-id="element-163">
            <h3 className="text-2xl font-black text-white mb-6 text-center" data-id="element-164">
              ✨ Incluye:
            </h3>
            <div className="flex items-center gap-4 text-gray-200 bg-[#c41e3a]/10 p-5 rounded-lg border-2 border-[#c41e3a]/30" data-id="element-165">
              <ZapIcon className="w-8 h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-166" />
              <span className="text-xl font-semibold" data-id="element-167">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-4 text-gray-200 bg-[#c41e3a]/10 p-5 rounded-lg border-2 border-[#c41e3a]/30" data-id="element-168">
              <CheckIcon className="w-8 h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-169" />
              <span className="text-xl font-semibold" data-id="element-170">Ebooks descargables</span>
            </div>
            <div className="flex items-center gap-4 text-gray-200 bg-[#c41e3a]/10 p-5 rounded-lg border-2 border-[#c41e3a]/30" data-id="element-171">
              <CheckIcon className="w-8 h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-172" />
              <span className="text-xl font-semibold" data-id="element-173">Bonus incluidos</span>
            </div>
            <div className="flex items-center gap-4 text-gray-200 bg-[#c41e3a]/10 p-5 rounded-lg border-2 border-[#c41e3a]/30" data-id="element-174">
              <CheckIcon className="w-8 h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-175" />
              <span className="text-xl font-semibold" data-id="element-176">
                Certificado al completar
              </span>
            </div>
          </div>

          {/* Order Bump con precios */}
          <div className="bg-[#0a0a0a] rounded-xl p-7 mb-10 border-2 border-[#c41e3a]/50" data-id="element-177">
            <label className="flex items-start gap-5 cursor-pointer group" data-id="element-178">
              <input type="checkbox" checked={includeColorimetria} onChange={e => setIncludeColorimetria(e.target.checked)} className="w-7 h-7 mt-1 rounded border-2 border-gray-400 text-[#c41e3a] focus:ring-2 focus:ring-[#c41e3a] focus:ring-offset-2 focus:ring-offset-[#0a0a0a] cursor-pointer" aria-label="Agregar formación en Colorimetría" data-id="element-179" />
              <div className="flex-1" data-id="element-180">
                <span className="text-white text-xl font-bold group-hover:text-gray-200 transition-colors block mb-3" data-id="element-181">
                  🎨 Agregar Colorimetría aplicada
                </span>
                <div className="flex items-center gap-3" data-id="element-182">
                  <span className="text-gray-500 line-through text-lg font-semibold" data-id="element-183">
                    ${colorimetriaPriceOriginal.toLocaleString('es-AR')}
                  </span>
                  <span className="text-[#c41e3a] font-black text-2xl" data-id="element-184">
                    ${colorimetriaPrice.toLocaleString('es-AR')}
                  </span>
                </div>
              </div>
            </label>
          </div>

          {/* Payment Icons */}
          <div className="flex flex-wrap items-center justify-center gap-6 mb-10 text-gray-400 text-base" data-id="element-185">
            <div className="flex items-center gap-2" data-id="element-186">
              <CreditCardIcon className="w-6 h-6" aria-hidden="true" data-id="element-187" />
              <span className="font-semibold" data-id="element-188">Mercado Pago</span>
            </div>
            <span className="text-2xl" data-id="element-189">·</span>
            <div className="flex items-center gap-2" data-id="element-190">
              <ShieldCheckIcon className="w-6 h-6" aria-hidden="true" data-id="element-191" />
              <span className="font-semibold" data-id="element-192">Compra segura</span>
            </div>
            <span className="text-2xl" data-id="element-193">·</span>
            <div className="flex items-center gap-2" data-id="element-194">
              <ZapIcon className="w-6 h-6" aria-hidden="true" data-id="element-195" />
              <span className="font-semibold" data-id="element-196">Acceso inmediato</span>
            </div>
          </div>

          {/* CTA Button */}
          <button className="w-full bg-gradient-to-r from-[#c41e3a] to-[#d91e5b] hover:from-[#a01830] hover:to-[#b01848] text-white font-black text-2xl px-12 py-6 rounded-xl transition-all duration-200 shadow-2xl hover:shadow-[#c41e3a]/50 hover:scale-105 transform" aria-label="Acceder a la formación ahora" data-id="element-197">
            👉 ACCEDER A LA FORMACIÓN AHORA
          </button>
        </div>
      </div>
    </section>;
}